<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" >

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto">
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">

                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Login</h4>
                  <p class="mb-4"> 로그인 아이디와 비밀번호를 입력하세요.</p>
                </div>

                <!-- <form @submit.prevent="submitForm"> -->
                   <div>
                    <vs-input
                        name="userId"
                        icon-no-border
                        
                        icon-pack="feather"
                        label-placeholder="아이디"
                        v-model="userId"
                        v-validate="'required'"
                        class="w-full mb-8" />
                    <span class="text-danger text-sm" v-show="errors.has('userId')">{{ errors.first('userId') }}</span>

                    <vs-input
                        type="password"
                        name="password"
                        icon-no-border
                        
                        icon-pack="feather"
                        label-placeholder="비밀번호"
                        v-model="password"
                        @keyup.enter="login"
                        class="w-full mt-6" />
                    <span class="text-danger text-sm" v-show="errors.has('password')">{{ errors.first('password') }}</span>

                    <div class="flex flex-wrap justify-between my-5">
                        <!-- <vs-checkbox v-model="checkbox_remember_me" class="mb-3">아이디 저장</vs-checkbox> -->
                        <!-- <router-link to="">Forgot Password?</router-link> -->
                    </div>
                    <!-- <vs-button  type="border">Register</vs-button> -->
                

                    <!-- <vs-divider>OR</vs-divider> -->

                    <div class="social-login-buttons flex flex-wrap items-center mt-4">
                     <vs-button class="float-right" @click="login" :disabled="!validateForm">로그인</vs-button> 
                     <!-- <button class="float-right" type="submit">로그인</button>-->
                      <!--<div class="bg-facebook pt-3 pb-2 px-4 rounded-lg cursor-pointer mr-4">
                        <svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="facebook-f" class="text-white h-4 w-4 svg-inline--fa fa-facebook-f fa-w-9" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 264 512"><path fill="currentColor" d="M215.8 85H264V3.6C255.7 2.5 227.1 0 193.8 0 124.3 0 76.7 42.4 76.7 120.3V192H0v91h76.7v229h94V283h73.6l11.7-91h-85.3v-62.7c0-26.3 7.3-44.3 45.1-44.3z"></path></svg>
                      </div>

                      <div class="bg-twitter pt-3 pb-2 px-4 rounded-lg cursor-pointer mr-4">
                        <svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="twitter" class="text-white h-4 w-4 svg-inline--fa fa-twitter fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"></path></svg>
                      </div>

                      <div class="bg-google pt-3 pb-2 px-4 rounded-lg cursor-pointer mr-4">
                        <svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="google" class="text-white h-4 w-4 svg-inline--fa fa-google fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 488 512"><path fill="currentColor" d="M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z"></path></svg>
                      </div>

                      <div class="bg-github pt-3 pb-2 px-4 rounded-lg cursor-pointer mr-4">
                        <svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="github-alt" class="text-white h-4 w-4 svg-inline--fa fa-github-alt fa-w-15" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 480 512"><path fill="currentColor" d="M186.1 328.7c0 20.9-10.9 55.1-36.7 55.1s-36.7-34.2-36.7-55.1 10.9-55.1 36.7-55.1 36.7 34.2 36.7 55.1zM480 278.2c0 31.9-3.2 65.7-17.5 95-37.9 76.6-142.1 74.8-216.7 74.8-75.8 0-186.2 2.7-225.6-74.8-14.6-29-20.2-63.1-20.2-95 0-41.9 13.9-81.5 41.5-113.6-5.2-15.8-7.7-32.4-7.7-48.8 0-21.5 4.9-32.3 14.6-51.8 45.3 0 74.3 9 108.8 36 29-6.9 58.8-10 88.7-10 27 0 54.2 2.9 80.4 9.2 34-26.7 63-35.2 107.8-35.2 9.8 19.5 14.6 30.3 14.6 51.8 0 16.4-2.6 32.7-7.7 48.2 27.5 32.4 39 72.3 39 114.2zm-64.3 50.5c0-43.9-26.7-82.6-73.5-82.6-18.9 0-37 3.4-56 6-14.9 2.3-29.8 3.2-45.1 3.2-15.2 0-30.1-.9-45.1-3.2-18.7-2.6-37-6-56-6-46.8 0-73.5 38.7-73.5 82.6 0 87.8 80.4 101.3 150.4 101.3h48.2c70.3 0 150.6-13.4 150.6-101.3zm-82.6-55.1c-25.8 0-36.7 34.2-36.7 55.1s10.9 55.1 36.7 55.1 36.7-34.2 36.7-55.1-10.9-55.1-36.7-55.1z"></path></svg>
                      </div> -->
                    </div> 
                  </div>
                <!-- </form> -->

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>

export default{
  data () {
    return {
      userId: '',
      password: '',
      checkbox_remember_me: false
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any() && this.id !== '' && this.password !== ''
    }
  },
  methods: {
    checkLogin () {
      // If user is already logged in notify
      /*if (this.$store.getters.isLogin()) {

        // Close animation if passed as payload
        this.$vs.loading.close()

        this.$vs.notify({
          title: 'Login Attempt',
          text: 'You are already logged in!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }*/
      return true
    },
    
    async login () {

      if (!this.checkLogin()) return
      // Loading
      this.$vs.loading()

      try {
        const userData = {
          userId: this.userId,
          password: this.password,
          checkbox_remember_me: this.checkbox_remember_me
        }

        await this.$store.dispatch('login', userData)
        this.$router.push('/dashboard')
      } catch (error) {
        
        this.$vs.loading.close()

        if (error.response.status === 500) {
          this.$vs.notify({
            title: 'Error',
            text: 'ID 또는 비밀번호가 일치하지 않습니다.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        } else if (error.response.status === 404) {
          this.$vs.notify({
            title: 'Error',
            text: '등록된 ID가 아닙니다.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          }) 
        } else {
          this.$vs.notify({
            title: 'Error',
            text: error.response.data.msg,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          }) 
        }
      }
    }
  },
  created () {
  }
}
</script>

<!--<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook { background-color: #1551b1 }
    .bg-twitter { background-color: #00aaff }
    .bg-google { background-color: #4285F4 }
    .bg-github { background-color: #333 }
  }
}
</style> -->
